export default {
  pageText: "{0} ru",
  noDataText: "Нет данных",
  appBar: {
    siteTitle: "Pазработка от первого лица",
    siteTitleCorp: "Strickland Software Engineering Corp.",
    siteTitleCorpSmall: "Strickland Software",
    projects: "проекты",
  },
  banner: {
    iosDescription: "Разработка приложений для мобильных устройств и AppleTV",
    androidDescription:
      "Разработка под Android для всех типов мобильных устройств и TV",
    serverDescription: "Разработка серверных АПИ для мобильных приложений",
  },
  detail: {
    privacyPolicy: "Политика конфиденциальности",
    terms: "Условия использования",
  },
  appList: {
    moreDetailed: "Подробнее...",
  },
  messageForm: {
    messageTitle: "Сообщение разработчику",
    message: "Сообщение",
    messageSuccess: "Сообщение отправлено",
    isRequired: "Поле должно быть заполнено",
    mustBeLess: "Поле должно содержать не более {0} символов",
    incorrectEmail: "Введите корректный email",
    sendButton: "Отправить",
    appField: "Приложение",
    nameField: "Имя",
    emailField: "Email",
  },
  not_found_component: {
    go_home: "На главную",
    description: "Упс... Ошибка 404 Приносим извинения, но страница, которую вы ищете, не существует."
  }
};
